import { pick } from 'underscore';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { BaseSchemaProcessor } from './base-schema-processor';

// shared budget summary page.
// keep columns align with the old ui grid.
export class SharedBudgetSchemaProcessor extends BaseSchemaProcessor {
  constructor(options) {
    super(options);
    this.Permissions = options.globalConfig.get('Permissions');
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = cloneDeep(entitySchema);
    const {
      IsViewThroughConversionsRevenueEnabled,
      IsViewThroughConversionEnabled,
      IsAvgPositionDeprecationPhase2Enabled,
      dynamic = {},
    } = this.Permissions;
    const {
      PartialConversions: IsPartialConversionsEnabled,
      ColumnConversion: IsColumnConversionEnabled,
    } = dynamic;
    const usePartialConversions = IsPartialConversionsEnabled && IsColumnConversionEnabled;


    const propertyList = [
      'Name',
      'PerformanceMetricsSpend',
      'PerformanceMetricsClicks',
      'PerformanceMetricsImpressions',
      'PerformanceMetricsCTR',
      'PerformanceMetricsAveragePosition',
      'PerformanceMetricsAverageCPC',
      usePartialConversions ? 'PerformanceMetricsConversionsCredit' : 'PerformanceMetricsConversions',
      usePartialConversions ? 'PerformanceMetricsAllConversionsCredit' : 'PerformanceMetricsAllConversions',
    ];

    if (IsViewThroughConversionEnabled) {
      propertyList.push(usePartialConversions ? 'PerformanceMetricsViewThroughConversionsCredit' : 'PerformanceMetricsViewThroughConversions');
    }

    if (IsViewThroughConversionsRevenueEnabled) {
      propertyList.push('PerformanceMetricsViewThroughConversionsRevenue');
      propertyList.push(usePartialConversions ? 'PerformanceMetricsViewThroughPartialConversionsCPA' : 'PerformanceMetricsViewThroughConversionsCPA');
      propertyList.push('PerformanceMetricsViewThroughConversionsReturnOnAdSpend');
      propertyList.push(usePartialConversions ? 'PerformanceMetricsViewThroughPartialConversionsRate' : 'PerformanceMetricsViewThroughConversionsRate');
    }

    if (IsAvgPositionDeprecationPhase2Enabled) {
      propertyList.push('PerformanceMetricsTopImpressionRate');
      propertyList.push('PerformanceMetricsAbsoluteTopImpressionRate');
    }

    updatedSchema.properties = pick(updatedSchema.properties, propertyList);

    return updatedSchema;
  }
}
